import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { projects } from '../../data/projects';
import '../../styles/work.css';

const WorkIndex = () => {
  const [active, setActive] = useState(null);
  const previewRef = useRef(null);
  const frameRef = useRef(0);

  const onMove = (e) => {
    if (frameRef.current) return;
    const { clientX, clientY } = e;
    frameRef.current = requestAnimationFrame(() => {
      frameRef.current = 0;
      if (previewRef.current) {
        previewRef.current.style.transform = `translate3d(${clientX}px, ${clientY}px, 0) translate(-50%, -50%)`;
      }
    });
  };

  return (
    <section className="section work" id="work" onMouseMove={onMove}>
      <div className="shell">
        <div className="section-head" data-reveal>
          <p className="eyebrow">Projets réalisés</p>
          <h2>
            Six projets, <em>du wireframe</em> à la mise en ligne
          </h2>
        </div>

        <ul className="work-list">
          {projects.map((project, index) => (
            <li
              key={project.slug}
              className="work-row"
              data-reveal
              style={{ '--reveal-delay': `${index * 70}ms` }}
              onMouseEnter={() => setActive(project)}
              onMouseLeave={() => setActive(null)}
            >
              <Link to={`/projets/${project.slug}`} className="work-link">
                <span className="work-index" aria-hidden="true">
                  {String(index + 1).padStart(2, '0')}
                </span>

                <span className="work-name">{project.title}</span>

                <span className="work-tail">
                  <span className="work-subtitle">{project.subtitle}</span>
                  <span className="work-year">{project.year}</span>
                  <ArrowUpRight className="work-arrow" size={22} aria-hidden="true" />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Aperçu qui suit le curseur */}
      <div
        className={`work-preview ${active ? 'is-visible' : ''}`}
        ref={previewRef}
        aria-hidden="true"
      >
        {active && <img src={active.image} alt="" loading="lazy" />}
      </div>
    </section>
  );
};

export default WorkIndex;
